export default "__VITE_ASSET___26cDF12__"